
import React from 'react';
import { LocalizedContent } from '../utils/localization';
import { 
  Accordion, 
  AccordionContent, 
  AccordionItem, 
  AccordionTrigger 
} from '@/components/ui/accordion';

interface FAQProps {
  content: LocalizedContent;
}

const FAQ: React.FC<FAQProps> = ({ content }) => {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Background video */}
      <div className="absolute inset-0 w-full h-full z-0">
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <iframe 
            src="https://streamable.com/e/fgtx2p?autoplay=1&nocontrols=1&muted=1&loop=1" 
            allow="fullscreen;autoplay" 
            allowFullScreen
            style={{ border: 'none', width: '100%', height: '100%', position: 'absolute', left: '0px', top: '0px', overflow: 'hidden', objectFit: 'cover' }}
            title="FAQ Background"
          ></iframe>
        </div>
      </div>
      
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/70 z-10"></div>
      
      {/* Content */}
      <div className="container mx-auto px-4 relative z-20">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white font-future">{content.faqTitle}</h2>
          
          <Accordion type="single" collapsible className="space-y-6">
            {content.faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="bg-[#15151D]/80 backdrop-blur-sm p-6 rounded-lg border border-purple-900/20">
                <AccordionTrigger className="text-xl font-semibold text-white">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-gray-400 pt-3">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
